import { Badge, MantineColor, Tooltip } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { OrderType } from '../data-access/types/orders';

interface OrderTypeProps {
  type: OrderType;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'filled' | 'light' | 'outline' | 'dot';
}

const getOrderTypeColor = (type: OrderType): MantineColor => {
  switch (type) {
    case OrderType.Carbon:
      return 'green';
    case OrderType.Density:
      return 'violet';
    case OrderType.Combo:
      return 'indigo';
    default:
      return 'gray';
  }
};

const getOrderTypeLabel = (type: OrderType): string => {
  switch (type) {
    case OrderType.Carbon:
      return 'sampling.order-type.carbon';
    case OrderType.Density:
      return 'sampling.order-type.density';
    case OrderType.Combo:
      return 'sampling.order-type.combo';
    default:
      return 'common.unknown';
  }
};

export const OrderTypePill: FC<OrderTypeProps> = ({
  type,
  size = 'md',
  variant = 'light',
}) => {
  const { t } = useTranslation();
  const label = t(getOrderTypeLabel(type));

  return (
    <Tooltip label={label} withArrow>
      <Badge
        color={getOrderTypeColor(type)}
        size={size}
        title={label}
        variant={variant}
      >
        {label}
      </Badge>
    </Tooltip>
  );
};

export { getOrderTypeColor, getOrderTypeLabel };
export default OrderTypePill;
